"use client"
import React from 'react'
import Link from "next/link"
import { FormattedMessage } from 'react-intl'
import { KeenIcon } from '../keenicons'

export default function Footer() {
    const year = new Date().getFullYear()
    return (
        <main>
            <footer className="footer">
                {/* Container */}
                <div className="container-fixed">
                    <div className="flex flex-col md:flex-row justify-center md:justify-between items-center gap-3 py-5">

                        <div className="flex order-1 md:order-1 gap-2 font-normal text-2sm">
                            <span className="text-gray-500">{year} ©</span>
                            <Link
                                className="text-gray-600 hover:text-primary"
                                href="/"
                            >
                                <FormattedMessage id="FOOTER.BRAND" />
                            </Link>
                        </div>
                        <div className="flex items-center gap-1 order-2 md:order-1 font-normal text-2sm text-gray-600 hover:text-primary">
                            <span>Made with</span>
                            <KeenIcon icon="heart" className="text-red-500" style="solid" />
                            <span>in India</span>
                        </div>


                    </div>
                </div>
                {/* End of Container */}
            </footer>
        </main>

    )
}
